import { render, staticRenderFns } from "./viewArea.vue?vue&type=template&id=39592542&scoped=true"
import script from "./viewArea.vue?vue&type=script&lang=js"
export * from "./viewArea.vue?vue&type=script&lang=js"
import style0 from "./viewArea.vue?vue&type=style&index=0&id=39592542&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39592542",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39592542')) {
      api.createRecord('39592542', component.options)
    } else {
      api.reload('39592542', component.options)
    }
    module.hot.accept("./viewArea.vue?vue&type=template&id=39592542&scoped=true", function () {
      api.rerender('39592542', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scenic-spot/viewArea.vue"
export default component.exports